import { getDefaultData } from './data'

export function getDefaultStore () {
  return getDefaultData()
}
